import React from 'react';
export const useShowMore = <T,>(items: T[], initialCount: number, step: number) => {
  const [visibleCount, setVisibleCount] = React.useState(initialCount);

  React.useEffect(() => {
    setVisibleCount(initialCount);
  }, [items, initialCount]);

  const showMore = React.useCallback(() => {
    setVisibleCount(prev => prev + step);
  }, [step]);

  const visibleItems = React.useMemo(() => items.slice(0, visibleCount), [items, visibleCount]);
  const hasMore = React.useMemo(() => visibleCount < items.length, [items.length, visibleCount]);

  return {
    hasMore,
    showMore,
    visibleItems,
  };
};
